import { render } from "./Commissions.vue?vue&type=template&id=50f78426"
import script from "./Commissions.vue?vue&type=script&lang=ts"
export * from "./Commissions.vue?vue&type=script&lang=ts"
script.render = render

export default script